(function() {
	'use strict';

	angular
		.module('serviciosocialApp')
		.controller('SSProyectoSolicitudController', SSProyectoSolicitudController);

	SSProyectoSolicitudController.$inject = [ '$timeout', '$scope', '$state', '$uibModal',
			'$stateParams', '$location', 'entity', 'selectedTab',
			'SSProyecto', 'SSArea', 'SSFuncion', 'SSModalidad', 'SSPerfil',
			'ProgramaEducativo', 'SSSector', 'SSAmbito', 'SSPeriodo',
			'SSMovimientoEstatusProyecto', 'SSEditarEstatusModalService', 'SSEnviarSolicitudModalService'];

	function SSProyectoSolicitudController($timeout, $scope, $state, $uibModal,
			$stateParams, $location, entity, selectedTab,
			SSProyecto, SSArea, SSFuncion, SSModalidad, SSPerfil,
			ProgramaEducativo, SSSector,SSAmbito, SSPeriodo, 
			SSMovimientoEstatusProyecto, SSEditarEstatusModalService, SSEnviarSolicitudModalService) {
		var vm = this;
				
		/* PARAMETROS */
		vm.sSProyecto = entity;
		vm.selectedTab = selectedTab;		
		
		/* NAVEGACION */
    	vm.previousSection = previousSection;
    	vm.nextSection = nextSection;

    	/* FORMULARIO */
		vm.ssareas = SSArea.query();
		vm.ssfuncions = SSFuncion.query();
		vm.ssmodalidads = SSModalidad.query();
		vm.programasEducativos = ProgramaEducativo.distinct();
		vm.sssectores = SSSector.query();
		vm.ssambitos = SSAmbito.query();
		vm.periodoVigente = "";
		vm.semestres = [ "1", "2", "3", "4" ];
		
		/* METODOS */
		vm.editarEstatus = null;
		vm.agregarPerfil = agregarPerfil;
		vm.editarPerfil = editarPerfil;
		vm.removerPerfil = removerPerfil;
		vm.save = save;
		vm.send = send;
		vm.clear = clear;

		loadProject();

		
		
		function loadProject() {
//			console.log("Estoy aca");
			/* Obtener periodo de convocatoria vigente */
			SSPeriodo.getPeriodoConvocatoriaVigente().$promise.then(onSuccess, onError);
			
			/* Si el proyecto está guardado */ 
			if (vm.sSProyecto.id !== null) {
				
				/* Y se ha registrado, mostrar tab de seguimiento */
				SSMovimientoEstatusProyecto.hasBeenRegistered({
						idProyecto : vm.sSProyecto.id
					}).$promise.then(function(result) {
						vm.showSeguimiento = result;
					});
				/* Obtener lista de estatusProyecto */ 				
				SSMovimientoEstatusProyecto.getByProyecto({
						idProyecto : vm.sSProyecto.id
					}).$promise.then(function(result) {
						vm.sSMovimientoEstatusProyectos = result;
					});
			}
			
			$scope.active = vm.selectedTab;
			if(vm.selectedTab == 0){
		    	vm.section = 1;				
			}
		}
		
		/* Si hay convocatoria vigente: 
		 * validaciones para habilitar/deshabilitar formulario y asignar periodo vigente */
		function onSuccess(result) {
//			console.log(result);
			var today = new Date();			
			if (vm.sSProyecto.id == null){
				vm.isDisabled = false;
				vm.periodoVigente = result;
			} else if (vm.sSProyecto.estatus == 'EDICION' || 
					(vm.sSProyecto.estatus == 'REPLANTEADO' && today <= vm.sSProyecto.periodoInicial.finPeriodo)) {
				vm.isDisabled = false;
				vm.periodoVigente = vm.sSProyecto.periodoInicial;
			} else {
				vm.isDisabled = true;
				vm.periodoVigente = vm.sSProyecto.periodoInicial;
			}
		}

		/* Si no hay convocatoria vigente:
		 * validaciones para habilitar/deshabilitar formulario y asignar periodo vigente */
		function onError() {
			var today = new Date();
			
			if(vm.sSProyecto.id == null){
				vm.isDisabled = true;
				vm.periodoVigente = null;
				
			} else if(vm.sSProyecto.estatus == 'REPLANTEADO' && today <= vm.sSProyecto.periodoInicial.finPeriodo){
				vm.isDisabled = false;
				vm.periodoVigente = vm.sSProyecto.periodoInicial;
			
			} else {
				vm.isDisabled = true;
				vm.periodoVigente = vm.sSProyecto.periodoInicial;
			}
		}
		
		/* Navegar a seccion anterior */
        function previousSection(){
        	if(vm.section > 1 && vm.section < 5){
        		validateProjectSaving();
        		vm.section = vm.section - 1;
        	}
        }

		/* Navegar a seccion siguiente */
        function nextSection(){
        	if(vm.section > 0 && vm.section < 4){
        		validateProjectSaving();
        		vm.section = vm.section + 1;
        	}
        }
        
        /* Valida si necesita guardarse el proyecto */
        function validateProjectSaving(){
    		if(vm.section !== 3 && $scope.editForm.$dirty){
    			save();
    		}
        }
        
        /* Guardar proyecto */
		function save() {
			
			if(vm.sSProyecto.aprobadoanteriormente){
				//Valida que el num del proyecto aprobado con anterioridad exista
				existeNumProy();
			}else{
				salvar();
			}

		}
		
		function salvar(){
			vm.isSaving = true;
			vm.sSProyecto.inicioVigencia = vm.periodoVigente.iniPeriodo;
			vm.sSProyecto.finVigencia = vm.periodoVigente.finPeriodo;
			validarRespDeProyecto();
			validarUnidadReceptora();
			asignarFinVigencia();
			asignarAmbito();
			if (vm.sSProyecto.id !== null) {
				SSProyecto.updateBySolicitante(vm.sSProyecto, onUpdateSuccess, onSaveError);
			} else {
				SSProyecto.save(vm.sSProyecto, onSaveSuccess, onSaveError);
			}
			vm.noExisProyAproAnt = false;
		}
		
		function existeNumProy(){
			vm.noExisProyAproAnt = false;
			var promise = SSProyecto.getProyAproAnteriormente({id : vm.sSProyecto.proyectoidanterior});
//			console.log(promise);
			
			promise.$promise.then(function (result) {
				//Sucess
				vm.noExisProyAproAnt = false;
				console.log(result);	
				salvar();
			
			}).catch(function (error) {
				//ERROR
				vm.noExisProyAproAnt = true;
	            console.log(error);
	        });
		}
		
		function onUpdateSuccess(result) {
			$scope.editForm.$setPristine();
			vm.isSaving = false;
			vm.sSProyecto = result;
		}

		function onSaveSuccess(result) {
			$scope.editForm.$setPristine();
			vm.isSaving = false;
			vm.sSProyecto = result;
			$state.go("ss-proyecto-solicitud", {id : result.id, section : 2});
		}

		function onSaveError() {
			vm.isSaving = false;
		}
        
		function asignarAmbito(){
			if (vm.sSProyecto.unidadesReceptoras[0].sector != null) {
				if (vm.sSProyecto.unidadesReceptoras[0].sector.id == 5)
					vm.sSProyecto.ambito = "INTERNO";
				else
					vm.sSProyecto.ambito = "EXTERNO";
			} else {
				vm.sSProyecto.ambito = null;
			}
		}

		function validarRespDeProyecto() {
			if (vm.sSProyecto.respDeProyectos.length == 1) {
				if (vm.sSProyecto.respDeProyectos[0].id == null) {
					if (vm.sSProyecto.respDeProyectos[0].nombres == null)
						vm.sSProyecto.respDeProyectos[0].nombres = '';
					if (vm.sSProyecto.respDeProyectos[0].primerApellido == null)
						vm.sSProyecto.respDeProyectos[0].primerApellido = '';
					if (vm.sSProyecto.respDeProyectos[0].segundoApellido == null)
						vm.sSProyecto.respDeProyectos[0].segundoApellido = '';
					if (vm.sSProyecto.respDeProyectos[0].cargo == null)
						vm.sSProyecto.respDeProyectos[0].cargo = '';
				}
			} else {
				console.log("respDeProyectos not properly setted.");
			}
		}

		function validarUnidadReceptora() {
			if (vm.sSProyecto.unidadesReceptoras.length == 1) {
				if (vm.sSProyecto.unidadesReceptoras[0].id == null) {
					if (vm.sSProyecto.unidadesReceptoras[0].institucion == null)
						vm.sSProyecto.unidadesReceptoras[0].institucion = '';
					if (vm.sSProyecto.unidadesReceptoras[0].unidadReceptora == null)
						vm.sSProyecto.unidadesReceptoras[0].unidadReceptora = '';
					if (vm.sSProyecto.unidadesReceptoras[0].dependencia == null)
						vm.sSProyecto.unidadesReceptoras[0].dependencia = '';
				} 
			} else {
				console.log("unidadesReceptoras not properly setted.");
			}
		}
		
		/**
		 * Este metodo se encarga de poner la fecha final de un proyecto con base al siguiente criterio:
		 * 
		 * Un semestre equivale a 6 meses de duracion
		 * # Semestres | Meses acumulados
		 * 1 semestres | 6 meses (Medio año)
		 * 2 semestres | 12 meses (Un año)
		 * 3 semestres | 18 meses (Un año y medio)
		 * 4 semestres | 24 meses (Dos años)
		 */
		function asignarFinVigencia(){
//			console.log("asignarFinVigencia");
			/*
			if (vm.sSProyecto.semestres == 1)
				vm.sSProyecto.finVigencia = vm.periodoVigente.finPeriodo;
			else 
				if(vm.sSProyecto.semestres == 2 && vm.periodoVigente.finPeriodo.getMonth() == 5) 
					vm.sSProyecto.finVigencia = new Date(vm.periodoVigente.finPeriodo.getFullYear(), 11, 31); // 31 de Dic del mismo año
				else
					if(vm.sSProyecto.semestres == 2 && vm.periodoVigente.finPeriodo.getMonth() == 11)
						vm.sSProyecto.finVigencia = new Date(vm.periodoVigente.finPeriodo.getFullYear()+1, 5, 30); // 30 de Junio del sig año
					else
						if(vm.sSProyecto.semestres == 3)
							vm.sSProyecto.finVigencia = new Date(vm.periodoVigente.finPeriodo.getFullYear()+1,vm.periodoVigente.finPeriodo.getMonth(),vm.periodoVigente.finPeriodo.getDate()); // la misma fecha del año siguiente
						else
							if (vm.sSProyecto.semestres == 4 && vm.periodoVigente.finPeriodo.getMonth() == 5)
								vm.sSProyecto.finVigencia = new Date(vm.periodoVigente.finPeriodo.getFullYear()+1, 11, 31); // 31 de Dic del siguiente año
							else 
								if(vm.sSProyecto.semestres == 4 && vm.periodoVigente.finPeriodo.getMonth() == 11)
									vm.sSProyecto.finVigencia = new Date(vm.periodoVigente.finPeriodo.getFullYear()+2, 5, 30); // 30 de Junio de dos años adelante
			*/ 
			// Primero veamos cuantos meses se quieren aniadir
			var semestres = vm.sSProyecto.semestres;
//			console.log("Semestres: "+semestres);
			var aniadirMeses = 0; //Dato variable dependiendo del numero de semestres
			switch (semestres) {//El dato semestre puede venir como numero o como cadena
			  case '1':
				  aniadirMeses = 6;
//				  console.log("case 1");
			    break;
			  case '2':
				  aniadirMeses = 12;
//				  console.log("case 2");
			    break;
			  case '3':
				  aniadirMeses = 18;
//				  console.log("case 3");
			    break;
			  case '4':
				  aniadirMeses = 24;
//				  console.log("case 4");
				break;
			  case 1:
				  aniadirMeses = 6;
//				  console.log("case 1");
			    break;
			  case 2:
				  aniadirMeses = 12;
//				  console.log("case 2");
			    break;
			  case 3:
				  aniadirMeses = 18;
//				  console.log("case 3");
			    break;
			  case 4:
				  aniadirMeses = 24;
//				  console.log("case 4");
				break;
			  default://Para que no se quede son nada en caso de que no se hayan puesto los semestres aun
				  aniadirMeses = 6;
//			  		console.log("case default");
			    break;
			}
//			console.log("aniadirMeses: "+aniadirMeses);
			//Optengamos la fecha inicio del proyecto
			var date = vm.periodoVigente.iniPeriodo;
			
			//Comenzamos a calcular la fecha fin del proyecto
			var baseMeses = 12;//Constante, no deberia cambiar
			var mesBase = date.getMonth();
			var anioBase = date.getFullYear();
			var sumAux = mesBase + aniadirMeses;
//			console.log("sumAux: "+sumAux);
			var mesFinal = baseMeses;
			var anioFinal = anioBase;
			if(sumAux > baseMeses){
			    var cocienteEntero = Math.floor(sumAux/baseMeses);
//			    console.log("cocienteEntero: "+cocienteEntero);
			    var resto = sumAux % baseMeses;
//			    console.log("resto: "+resto);
			    if(resto !=0){
			        mesFinal = resto;
			        anioFinal = anioBase + cocienteEntero;
			    }else{
			        if(cocienteEntero>1){
			            anioFinal = anioBase + (cocienteEntero-1);
			        }
			    }
			}else{
			    mesFinal = sumAux;
//			    console.log("anioFinal: "+anioFinal);
			}
			// Se le tiene que restar -1 para que concuerde con el sistema de que enero es 0
			mesFinal = mesFinal - 1;
//			console.log("Mes:"+mesFinal);
//			console.log("Anio:"+anioFinal);
			var fechaDia = new Date(anioFinal, mesFinal, 1); 
			var diaFechaFinal = new Date(fechaDia.getFullYear(), fechaDia.getMonth() + 1, 0);
			var diaFinal = diaFechaFinal.getDate();
			vm.sSProyecto.finVigencia = new Date(anioFinal, mesFinal, diaFinal); 
//			console.log("Vigencia fin: "+vm.sSProyecto.finVigencia);
			
		}

		function agregarPerfil() {
			if (vm.sSProyecto.perfils == null) {
				vm.sSProyecto.perfils = [];
			}			
		    var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-proyecto/ss-perfil-proyecto/ss-perfil-proyecto.html',
                controller: 'SSPerfilProyectoController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            programaEducativo: null,
                            solicitados: null,
            				actividads : [],
            				respDePrestadors : [],
                        };
                    }
                }
            });
		      modalInstance.result.then(function (newPerfil) {
		    	  	vm.isSaving = true;
			    	var perfilToSave = newPerfil;
			        SSProyecto.savePerfilBySolicitante({
			        	perfil: perfilToSave, 
			        	proyecto: vm.sSProyecto.id},
			            function (result) {
							$scope.editForm.$setPristine();
							vm.isSaving = false;
							vm.sSProyecto = result;
			        });
		      }, function () {
		      });
		}
		
		function editarPerfil(index, perfil) {
		    var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-proyecto/ss-perfil-proyecto/ss-perfil-proyecto.html',
                controller: 'SSPerfilProyectoController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return perfil;
                    }
                }
            });
		    modalInstance.result.then(function (editedPerfil) {
		    	vm.isSaving = true;
		    	var perfilToSave = editedPerfil;
		        SSProyecto.savePerfilBySolicitante({
					perfil: perfilToSave, 
					proyecto: vm.sSProyecto.id},
		            function (result) {	        	
						$scope.editForm.$setPristine();
						vm.isSaving = false;
			            vm.sSProyecto = result;
		        	});
		    	}, function () {
		    	});
		}

		function removerPerfil(index) {
			vm.isSaving = true;
			var perfilToDelete = vm.sSProyecto.perfils[index];
            SSProyecto.deletePerfilBySolicitante({sSProyecto: vm.sSProyecto.id, sSPerfil: perfilToDelete.id},
            	function (result) {
            		vm.isSaving = false;
            		vm.sSProyecto = result;
            	});
		}
		
		function send() {
			SSEnviarSolicitudModalService.open();
		}

		function clear() {
			$state.go("ss-proyectos");
		}

	}
})();
